import { formatNameLastFirst, formatPhoneNumber } from '@strata/helper-functions';
import { InfoDialog } from '@strata/react-dialog';
import { FormSectionRow } from '@strata/react-form-section';
import { MailToHyperlink } from '@strata/react-hyperlink';
import { AddressDetailLabelValue, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

export const ContactInfoDialog = ({ isOpen, onClose, referralData = undefined }) => (
    <InfoDialog
        dialogTitle="Contact Information"
        isOpen={isOpen}
        onClose={onClose}
        dialogContent={
            <>
                <FormSectionRow
                    rowContent={
                        <DetailLabelValuePair
                            label="Patient Name"
                            value={formatNameLastFirst(
                                referralData?.memberLastName,
                                referralData?.memberFirstName,
                            )}
                        />
                    }
                />
                <FormSectionRow
                    rowContent={
                        <>
                            <DetailLabelValuePair
                                style={{ width: '50%' }}
                                label="Phone"
                                value={formatPhoneNumber(referralData?.memberPhone)}
                            />
                            <DetailLabelValuePair
                                style={{ width: '50%' }}
                                label="Email"
                                value={<MailToHyperlink emailAddress={referralData?.memberEmail} />}
                            />
                        </>
                    }
                />
                <FormSectionRow
                    rowContent={
                        <AddressDetailLabelValue
                            label="Address"
                            address1={referralData?.memberAddress1}
                            address2={referralData?.memberAddress2}
                            city={referralData?.memberCity}
                            state={referralData?.memberState}
                            zip={referralData?.memberZip}
                        />
                    }
                />
            </>
        }
    />
);

ContactInfoDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    referralData: PropTypes.shape({
        memberFirstName: PropTypes.string,
        memberLastName: PropTypes.string,
        memberPhone: PropTypes.string,
        memberEmail: PropTypes.string,
        memberAddress1: PropTypes.string,
        memberAddress2: PropTypes.string,
        memberCity: PropTypes.string,
        memberState: PropTypes.string,
        memberZip: PropTypes.string,
    }),
};
